module.exports = __webpack_public_path__ + "static/media/facebook.6d395f91.svg";